// extracted by mini-css-extract-plugin
export default {"l":"_39d20bb08f"};